﻿import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, OnChanges, SimpleChanges, ChangeDetectorRef, NgZone } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { DataService } from '../../../service/data.service';
import { AppService } from '../../../service/app.service';
import { PreviewPictureComponent } from '../preview-picture/preview-picture.component';
import { ImageAnnotatorModalComponent } from '../image-annotator-modal/image-annotator-modal.component';
import { NativeService } from 'src/app/providers/NativeService';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { File } from '@ionic-native/file/ngx';
import { LocalStorageService } from 'src/app/service';
import { ActionSheetController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { FileService } from '../../../service/file.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import * as dd from 'dingtalk-jsapi'; // 引入钉钉jsapi
import { resolve } from 'dns';

declare var wx: any;
@Component({
	selector: 'app-select-picture-new',
	templateUrl: './select-picture-new.component.html',
	styleUrls: ['./select-picture-new.component.scss'],
})
export class SelectPictureNewComponent implements OnInit, OnChanges {
	@Input() fieldIds: any; // 文件id字符串
	@Input() editable: boolean; // 是否为可编辑的文件显示
	@Input() fileDTOs: any;
	@Input() isCamera: boolean;
	@Input() onlyOne: boolean; // 只能上传一个

	// 是否可以选择图片来源，可用选项为CAMERA_ONLY（只使用相机）和BOTH（用户选择相机或图库）
	@Input() sourceMode: string = 'BOTH';

	// 是否保存到相册
	@Input() saveToPhotoAlbum = false;
	// 0 相册； Choose image from the device's photo library (same as SAVEDPHOTOALBUM for Android)
	// 1 相机； Take picture from camera
	// 2 相册; Choose image only from the device's Camera Roll album (same as PHOTOLIBRARY for Android)
	@Input() pictureSourceType = 0;

	@Input() setUp: any;
	@Output() fileObjListChange = new EventEmitter<any>(); // 事件返回文件
	@ViewChild('picker') picker: ElementRef; // 上传文件的输入框

	localData;
	files: any[] = []; // 图片数组
	fileBlobUrls: string[] = [];
	android = false;
	isH5 = JSON.parse(this.localStorageService.getStore('isH5'));
	isMobileWeb = this.nativeService.isMobileWeb();
	previewImgs: any[] = []; //预览图片数组
	loading;

	constructor(
		private modalController: ModalController,
		private dataService: DataService,
		private appService: AppService,
		private nativeService: NativeService,
		private camera: Camera,
		private file: File,
		public localStorageService: LocalStorageService,
		private changeDetectorRef: ChangeDetectorRef,
		private actionSheetController: ActionSheetController,
		private translateService: TranslateService,
		private navController: NavController,
		private router: Router,
		private zone: NgZone,
		public fileService: FileService,
		private sanitizer: DomSanitizer
	) {
		// console.log('isH5', this.isMobileWeb)
	}

	ngOnInit() {
		// 下载文件
		this.downloadFile();
		if (!this.editable && this.fileDTOs) {
			this.files = this.fileDTOs;
			this.fileBlobUrls = Array(this.files.length).fill('');
		}

		this.android = this.nativeService.isAndroid();

		// console.log('附件上传判断', this.nativeService.isAndroid(), this.nativeService.isIos(), document.getElementById('filefieldIds'));
		// var obj1 = document.getElementById('file');
		// if(this.nativeService.isAndroid()) {
		// 	obj1.setAttribute('capture','camera');
		// } else {
		// 	obj1.removeAttribute('capture');
		// }
		// var plateform = Zepto.device.os;
		// if(plateform == "android"){
		// 	$("selector").find("input[type='file']").attr("capture","camera");
		// }else if(plateform=="ios"){
		// 	$("selector").find("input[type='file']").removeAttr("capture");
		// }
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['fieldIds'] && !changes['fieldIds'].isFirstChange()) {
			this.files = [];
			this.fileBlobUrls = [];
			this.downloadFile();
		}
		if (!this.editable && this.fileDTOs) {
			this.files = this.fileDTOs;
			this.fileBlobUrls = Array(this.files.length).fill('');
		}
	}

	// 获取图片dto
	getFileDTOs() {
		return this.files;
	}

	sanitize(url: string) {
		return this.sanitizer.bypassSecurityTrustUrl(url);
	}

	// 转base64
	convertImgToBase64(path: string): Observable<string> {
		return Observable.create(observer => {
			this.fileService.getFileBlob(path).then(blob => {
				const reader = new FileReader();
				reader.onloadend = function (e) {
					observer.next(this.result);
				};
				reader.readAsDataURL(blob);
			}).catch(err => {
				console.log(err, '根据图片转化为base64字符串失败');
				observer.error(false);
			});
		});
	}

	createObjectURL(blob: Blob): string {
		return URL.createObjectURL(blob);
	}

	getFileBlob(url: string): Promise<Blob> {
		return this.fileService.getFileBlob(url);
	}

	// 选择并上传图片
	async uploadFile() {

		// 旧
		// 用 Array.from 快照 FileList，避免重置 input 后 FileList 被清空
		const files = Array.from(this.picker.nativeElement.files as FileList);
		if (!files || files.length === 0) {
			return;
		}
		// 立即重置 input value，确保同一文件下次仍能触发 change 事件
		this.picker.nativeElement.value = '';
		this.loading = true
		for (let i = 0; i < files.length; i++) {
			const formData = new FormData();
			formData.append('file', files[i]);
			// formData.append('name', name);
			this.dataService.uploadFile(formData).subscribe(res => {
				if (!res.DATA) {
					this.loading = false;
					this.appService.toastTip(res.MSG, false);
				} else {
					const data = res.DATA;
					this.downloadSingleFile(data.id).then(resOut => {
						let fieldIds = '';
						this.files.forEach((element, index) => {
							if (index !== this.files.length - 1) {
								fieldIds += element.id + ',';
							} else {
								fieldIds += element.id;
							}
						});
						this.loading = false
						this.fileObjListChange.emit(fieldIds);
					});
				}
			}, (err) => {
				this.loading = false;
				this.appService.toastTip('shared_components.common.get_data_failed', true);
			});
		}

		// 新
		// let that = this;
		// const files = this.picker.nativeElement.files;
		// if (!this.isH5) {
		// 	for (let i = 0; i < files.length; i++) {
		// 		const formData = new FormData();
		// 		formData.append('file', files[i]);

		// 		await that.imageCompress(files[i]);
		// 		// formData.append('name', name);
		// 		this.dataService.uploadFile(formData).subscribe(res => {
		// 			if (!res.DATA) {
		// 				that.loading = false
		// 				this.appService.toastTip(res.MSG, false);
		// 			} else {
		// 				const data = res.DATA;
		// 				this.downloadSingleFile(data.id).then(resOut => {
		// 					this.zone.run(() => {
		// 						let fieldIds = '';
		// 						this.files.forEach((element, index) => {
		// 							if (index !== this.files.length - 1) {
		// 								fieldIds += element.id + ',';
		// 							} else {
		// 								fieldIds += element.id;
		// 							}
		// 						});
		// 						this.fileObjListChange.emit(fieldIds);
		// 						that.loading = false
		// 					});
		// 				});
		// 			}
		// 		}, (err) => {
		// 			that.loading = false
		// 			that.previewImgs = []
		// 			this.appService.toastTip('shared_components.common.get_data_failed', true);
		// 		});
		// 	}
		// } else {
		// 	for (let i = 0; i < files.length; i++) {
		// 		const fileData = files[i];
		// 		await this.imageCompress(fileData);
		// 	}

		// }

	}

	async imageCompress(imageData) {
		// 原scc
		let that = this;
		var image = new Image();
		let dataURL = null;
		const path = URL.createObjectURL(imageData);
		image.onload = function () {
			var width = image.width;
			var height = image.height;
			var quality = 50;
			const canvas = document.createElement("canvas");
			canvas.width = image.width;
			canvas.height = image.height;
			const ctx = canvas.getContext('2d');
			ctx.drawImage(image, 0, 0, width, height);
			dataURL = canvas.toDataURL(imageData.type, quality / 100);
			that.previewImgs = [dataURL, ...that.previewImgs]
			let blob = that.dataURLtoBlob(dataURL);
			const formData = new FormData();
			// formData.append('file', files[i]);
			formData.append("file", blob, imageData.name);
			if (that.isH5) {
				that.dataService.uploadFile(formData).subscribe(res => {
					if (!res.DATA) {
						that.appService.toastTip(res.MSG, false);
					} else {
						const data = res.DATA;
						that.downloadSingleFile(data.id).then(resOut => {
							that.zone.run(() => {
								let fieldIds = '';
								that.files.forEach((element, index) => {
									if (index !== that.files.length - 1) {
										fieldIds += element.id + ',';
									} else {
										fieldIds += element.id;
									}
								});
								that.fileObjListChange.emit(fieldIds);
								that.loading = false
							});
						});
					}
				}, (err) => {
					that.loading = false
					that.previewImgs = []
					that.appService.toastTip('shared_components.common.get_data_failed', true);
				});
			}
		}
		image.src = path;
	}

	dataURLtoBlob(dataurl) {
		var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
			bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}
		return new Blob([u8arr], { type: mime });
	}

	// 查看图片
	viewPicture(event, index, file) {
		// 旧
		// if (this.isH5) {
		// 	const picturePaths = [];
		// 	this.files.forEach(element => {
		// 		picturePaths.push(element.path);
		// 		//			if (this.isFilePicture(element.preview)) {
		// 		//				picturePaths.push(element.path);
		// 		//			} else {
		// 		//				picturePaths.push(document.location.origin + element.preview);
		// 		//			}
		// 	});
		// 	history.pushState(null, null, document.URL);

		// 	this.modalController.create({
		// 		component: PreviewPictureComponent,
		// 		componentProps: {
		// 			'initialSlide': index,
		// 			'picturePaths': picturePaths
		// 		},
		// 		showBackdrop: true,
		// 		backdropDismiss: true,
		// 		cssClass: ['preview-picture']
		// 	}).then(res => {
		// 		res.present();
		// 	});
		// } else {
		// 	window.open(file.path, 'Download');
		// }

		// 立即检查塞两层空路由
		const hashStr = window.location.hash;
		if (hashStr.indexOf('add-finding-page') !== -1 || hashStr.indexOf('finding-page') !== -1) {
			history.pushState(null, null, document.URL);
			history.pushState(null, null, document.URL);
		}
		// 新

		const blobUrl = this.fileBlobUrls[index];
		const displayUrl = (blobUrl && blobUrl !== '') ? blobUrl : (file.path ? file.path : file);
		this.router.navigate(['/shared/pic-single'], {
			queryParams: {
				url: displayUrl,
			}
		});
		event.stopPropagation();

	}

	userDownloadFile(event, index) {
		// 旧
		// if (!this.isH5) {
		// 	window.open(this.files[index].download, 'Download');
		// }
		// 新
		const urls = [];
		this.files.forEach(file => {
			urls.push(file.path);
		})
		this.router.navigate(['pic-slides'], {
			queryParams: {
				initialIndex: index,
				urls: JSON.stringify(urls)
			}
		});
		event.stopPropagation();

		// history.pushState(null, null, document.URL);

		// const picturePaths = [];
		// this.files.forEach(element => {
		// 	picturePaths.push(element.path);
		// 	//			if (this.isFilePicture(element.preview)) {
		// 	//				picturePaths.push(element.path);
		// 	//			} else {
		// 	//				picturePaths.push(document.location.origin + element.preview);
		// 	//			}
		// });
		// this.modalController.create({
		// 	component: PreviewPictureComponent,
		// 	componentProps: {
		// 		'initialSlide': index,
		// 		'picturePaths': picturePaths
		// 	},
		// 	showBackdrop: true,
		// 	backdropDismiss: true,
		// 	cssClass: ['preview-picture']
		// }).then(res => {
		// 	res.present();
		// });
	}

	// 移除选取的图片
	removePicture(index) {
		this.previewImgs = this.previewImgs.filter((res, i) => index !== i)
		this.files = this.files.filter((res, i) => index !== i);
		this.fileBlobUrls = this.fileBlobUrls.filter((res, i) => index !== i);
		let fieldIds = '';
		this.files.forEach((res, i) => {
			if (i !== this.files.length - 1) {
				fieldIds += res.id + ',';
			} else {
				fieldIds += res.id;
			}
		});
		this.fileObjListChange.emit(fieldIds);
	}

	clearAllPictures() {
		this.files = [];
		this.fileBlobUrls = [];
		this.fileObjListChange.emit('');
		if (this.picker && this.picker.nativeElement) {
			this.picker.nativeElement.value = '';
		}
	}

	// 下载文件
	async downloadFile() {
		if (this.fieldIds  && this.fieldIds.length) {
			let fileIdArr = this.fieldIds.split(',');
			for (let item of fileIdArr) {
				if (item && !this.files.find(f => f.id === item)) {
					await this.downloadSingleFile(item, true);
				}
			}
		}
	}

	async downloadSingleFile(element, isInit?): Promise<any> {
		let promise = new Promise<void>((resolve, reject) => {
			this.dataService.getFile(element).subscribe(res => {
				if (res.DATA) {
					const tmpFile = {
						id: res.DATA.id,
						download: res.DATA.path,
						path: res.DATA.path,
						originalName: res.DATA.originalName,
						type: res.DATA.type,
						size: res.DATA.size
					};
					if (this.files.filter(e => res.DATA.id === e.id).length === 0) {
						const slotIndex = this.files.length;
						this.files.push(tmpFile);
						this.fileBlobUrls.push(''); // 预占位，保证下标与 files 对齐
						this.fileService.getFileBlob(tmpFile.path).then(blob => {
							this.zone.run(() => {
								this.fileBlobUrls[slotIndex] = URL.createObjectURL(blob);
							});
						});
						// this.convertImgToBase64(tmpFile.path).subscribe(res => {
						// 	this.fileBlobUrls.push(res);
						// 	// 页面进入初始化阶段，没有值则没有回填，此时往里面塞值
						// 	if (isInit) {
						// 		this.previewImgs.push(res);
						// 	}
						// });
					}
					resolve();
				} else {
					this.appService.toastTip('shared_components.select_picture_new.attachement_download_fail', true);
					reject();
				}
			}, (e) => console.log(e));
		}).catch((err) => {
			this.appService.toastTip('shared_components.select_picture_new.attachement_download_fail', true)
		});
		return promise;
	}

	isFilePicture(previewPath: string) {
		// console.log(previewPath, previewPath[0]);
		return previewPath && previewPath[0] !== '/';
	}

	getFullPreviewPath(previewPath) {
		return document.location.origin + previewPath;
	}

	async chooseImageAndroid() {
		switch (this.sourceMode) {
			case 'BOTH':
				const actionSheet = await this.actionSheetController.create({
					header: this.translateService.instant('shared_components.select_picture_new.select_image_source'),
					buttons: [{
						text: this.translateService.instant('shared_components.select_picture_new.load_from_gallery'),
						cssClass: 'image-selection-text',
						handler: () => {
							this.androidFile(this.camera.PictureSourceType.PHOTOLIBRARY);
						}
					},
					{
						text: this.translateService.instant('shared_components.select_picture_new.use_camera'),
						cssClass: 'image-selection-text',
						handler: () => {
							this.androidFile(this.camera.PictureSourceType.CAMERA);
						}
					},
					{
						text: this.translateService.instant('shared_components.select_picture_new.use_file'),
						cssClass: 'image-selection-text',
						handler: () => {
							this.chooseAnyFile(); // 新增方法处理任意文件选择
						}
					},
					{
						text: this.translateService.instant('shared_components.select_picture_new.cancel_key'),
						cssClass: 'image-selection-text',
						role: 'cancel'
					}
					]
				});
				await actionSheet.present();
				break;

			case 'CAMERA_ONLY':
				this.androidFile(this.camera.PictureSourceType.CAMERA);
				break;
		}
	}

	// 新增方法：选择任意文件类型
	async chooseAnyFile() {
		console.log('1111');
		// try {
		//     // 使用FileChooser插件选择文件
		//     const fileUri = await this.fileChooser.open();

		//     // 在Android上解析文件路径
		//     const resolvedPath = await this.filePath.resolveNativePath(fileUri);

		//     // 读取文件信息
		//     const fileEntry = await this.resolveLocalFileSystem(resolvedPath);

		//     // 读取文件为Base64
		//     const fileData = await this.readFileAsBase64(fileEntry);

		//     // 获取文件名和类型
		//     const fileName = resolvedPath.substring(resolvedPath.lastIndexOf('/') + 1);
		//     const fileType = this.getFileType(fileName);

		//     // 处理文件预览和上传
		//     this.handleFileUpload(fileData, fileName, fileType);
		// } catch (err) {
		//     console.error('选择文件错误:', err);
		//     this.appService.toastTip('file_selection_failed', true);
		// }
	}

	androidFile(sourceType) {
		let that = this;
		// console.log('点击了');
		// var sourceType = that.camera.PictureSourceType.CAMERA
		// if (this.pictureSourceType === 0){
		// 	sourceType = that.camera.PictureSourceType.PHOTOLIBRARY
		// }else if (this.pictureSourceType === 1){
		// 	sourceType = that.camera.PictureSourceType.CAMERA
		// }else if (this.pictureSourceType === 2){
		// 	sourceType = that.camera.PictureSourceType.SAVEDPHOTOALBUM
		// }

		// 旧
		// const options: CameraOptions = this.isH5 ? {
		// 		quality: 50,
		// 		destinationType: that.camera.DestinationType.DATA_URL,
		// 		encodingType: that.camera.EncodingType.JPEG,
		// 		mediaType: that.camera.MediaType.PICTURE
		// 	} : {
		// 		quality: 50,
		// 		destinationType: that.camera.DestinationType.DATA_URL,
		// 		encodingType: that.camera.EncodingType.JPEG,
		// 		mediaType: that.camera.MediaType.PICTURE,
		// 		targetWidth: 720,
		// 		saveToPhotoAlbum: false,
		// 		sourceType: sourceType
		// 	}

		// 新
		const options: CameraOptions = {
			quality: 50,
			destinationType: that.camera.DestinationType.DATA_URL,
			encodingType: that.camera.EncodingType.JPEG,
			mediaType: that.camera.MediaType.PICTURE,
			targetWidth: 720,
			saveToPhotoAlbum: false,
			sourceType: sourceType
		}
		that.camera.getPicture(options).then((imageData) => {
			// 强制更新视图
			that.zone.run(() => {
				that.loading = true
				let base64Image = 'data:image/jpeg;base64,' + imageData;
				that.previewImgs = [base64Image, ...that.previewImgs]
			})
			const formData = new FormData();
			formData.append('file', imageData);

			that.dataService.uploadFileApp(formData).subscribe(res => {
				if (!res.DATA) {
					// 强制更新视图
					that.zone.run(() => {
						that.loading = false
					})

					that.appService.toastTip(res.MSG, false);
				} else {
					const data = res.DATA;
					that.downloadSingleFile(data.id).then(resOut => {
						that.zone.run(() => {
							let fieldIds = '';
							that.files.forEach((element, index) => {
								if (index !== that.files.length - 1) {
									fieldIds += element.id + ',';
								} else {
									fieldIds += element.id;
								}
							});
							that.fileObjListChange.emit(fieldIds);
							that.loading = false
						})

					});
				}
			}, (err) => {
				// 强制更新视图
				that.zone.run(() => {
					that.loading = false
				})
				that.appService.toastTip('shared_components.common.get_data_failed', true);
			});
		}, (err) => {
			// 强制更新视图
			that.zone.run(() => {
				that.loading = false
			})
		}).catch(() => {
			// 强制更新视图
			that.zone.run(() => {
				that.loading = false
			})
		}).finally(() => {
			// 强制更新视图
			// that.zone.run(() => {
			// 	that.loading = false
			// })
		});
	}


	chooseImage() {
		const that = this;
		let sourceType = ['album', 'camera'];
		if (that.setUp && that.setUp.length) {
			sourceType = that.setUp;
		}
		wx.ready(function () {
			wx.chooseImage({
				count: 1, // 默认9
				sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有'original',
				sourceType: sourceType, // 可以指定来源是相册还是相机，默认二者都有
				defaultCameraMode: "normal", //表示进入拍照界面的默认模式，目前有normal与batch两种选择，normal表示普通单拍模式，batch表示连拍模式，不传该参数则为normal模式。从3.0.26版本开始支持front和batch_front两种值，其中front表示默认为前置摄像头单拍模式，batch_front表示默认为前置摄像头连拍模式。（注：用户进入拍照界面仍然可自由切换两种模式）
				isSaveToAlbum: 1, //整型值，0表示拍照时不保存到系统相册，1表示自动保存，默认值是1
				success: function (res) {
					var localIds = res.localIds; // 返回选定照片的本地ID列表，
					const formData = new FormData();
					// alert(localIds);
					wx.getLocalImgData({
						localId: localIds[0],
						success: (result) => {
							var localData = result.localData; // localData是图片的base64数据，可以用img标签显示
							// if (localData.indexOf('data:image') != 0) {
							// 	//判断是否有这样的头部
							// 	localData = 'data:image/jpeg;base64,' +  localData
							// }
							// localData = localData.replace(/\r|\n/g, '').replace('data:image/jgp', 'data:image/jpeg')

							if (this.android) {
								that.localData = localData.slice(22);
							} else {
								that.localData = localData.slice(22);
							}
							//第一个替换的是换行符，第二个替换的是图片类型，因为在IOS机上测试时看到它的图片类型时jgp，
							// alert(localData.substring(0,40));
							let base64Image = 'data:image/jpeg;base64,' + localData;
							formData.append('file', that.localData);
							that.previewImgs = [base64Image, ...that.previewImgs]
							that.dataService.uploadFileApp(formData).subscribe(member => {
								if (!member.DATA) {
									that.loading = false
									that.appService.toastTip(member.MSG, false);
								} else {
									// alert(member.DATA[0]);
									const data = member.DATA;
									that.downloadSingleFile(data.id).then(resOut => {
										that.zone.run(() => {
											let fieldIds = '';
											that.files.forEach((element, index) => {
												if (index !== that.files.length - 1) {
													fieldIds += element.id + ',';
												} else {
													fieldIds += element.id;
												}
											});
											that.fileObjListChange.emit(fieldIds);
											that.changeDetectorRef.detectChanges();
											that.loading = false
										})
									});
								}
							}, (err) => {
								that.loading = false
								that.appService.toastTip('shared_components.common.get_data_failed', true);
							});
							// andriod中localId可以作为img标签的src属性显示图片；
							// iOS应当使用 getLocalImgData 获取图片base64数据，从而用于img标签的显示（在img标签内使用 wx.chooseImage 的 localid 显示可能会不成功）
						}
					})
				}
			});
		});
		// });
	}


	// ==========================================================
	// 判断文件是不是图片
	isPicSuffix(fileObj) {
		// console.log('fileObj:', fileObj);
		let typeStr = '';
		if (fileObj && fileObj.originalName && fileObj.type) {
			typeStr = fileObj.originalName + fileObj.type;
		}
		const strUpper = typeStr.toString().toUpperCase();
		if (strUpper.indexOf('JPG') > -1 ||
			strUpper.indexOf('JPEG') > -1 ||
			strUpper.indexOf('PNG') > -1 ||
			strUpper.indexOf('GIF') > -1 ||
			strUpper.indexOf('BMP') > -1 ||
			strUpper.indexOf('ICO') > -1 ||
			strUpper.indexOf('WEBP') > -1 ||
			strUpper.indexOf('SVG') > -1) {
			return true
		} else {
			return false;
		}
	}

	viewFile(file) {
		if (file.type == '.pdf') {
			this.navController.navigateForward(['/shared/preview-file'], {
				queryParams: {
					filePath: file.path,
					file: JSON.stringify(file)
				}
			});
		} else 
			// if (file.type == '.doc' || file.type == '.docx' 
			// || file.type == '.xls' || file.type == '.xlsx'
			// || file.type == '.ppt' || file.type == '.pptx') 
		{
			this.fileService.downloadFileFromEncodedStream(file.path, file.originalName, file.type);
			// this.navController.navigateForward(['/view-ppt'], {
			// 	queryParams: {
			// 		url: file.path,
			// 		// file: JSON.stringify(file)
			// 	}
			// });
			// if (this.isH5) { // 企业微信--安卓
				// this.fileService.getFileBlob(file.path).then(blob => {
				// 	const url = URL.createObjectURL(blob);
				// 	wx.ready(function () {
				// 		alert('previewFile');
				// 		wx.previewFile({
				// 			url: url, // 需要预览文件的地址(必填，可以使用相对路径)
				// 			name: file.originalName, // 需要预览文件的文件名，必须有带文件格式的后缀，例如.doc(不填的话取url的最后部分，最后部分是个包含格式后缀的文件名)
				// 			size: file.size // 需要预览文件的字节大小(必填，而且大小必须正确，否则会打开失败)
				// 		});
				// 	})
				// });
				// this.navController.navigateForward(['/view-ppt'], {
				// 	queryParams: {
				// 		url: file.path,
				// 		// file: JSON.stringify(file)
				// 	}
				// });
				// this.appService.toastTip(this.translateService.instant('API_ERROR_MSG.FILE_FOMART_ERROR'), true);
			// } else {
				// window.open(file.path, 'Download');
				// this.fileService.getFileBlob(file.path).then(blob => {
					// const url = URL.createObjectURL(blob);
					// const a = document.createElement('a')
					// a.href = url
					// a.download = file.originalName;
					// a.click();
				// });

			// }
		}

	}

	// 打开手机摄像头拍照
	openCamera() {
		const android = this.nativeService.isAndroid();
		const ios = this.nativeService.isIos();

		if (this.isH5) {
			// 企业微信(安卓)H5：cordova camera 插件不可用，必须走企业微信 JSSDK 才能拉起相机
			this.chooseImageWeComCameraOnly();
			return;
		}

		const that = this;
		const constraints = { video: { 
			facingMode: 'environment' ,        
			// width: { ideal: 1080 },  // 期望  1920×1080
			// height: { ideal: 1920 }
		}, }; // 后置摄像头

		navigator.mediaDevices.getUserMedia(constraints)
			.then((stream) => {
				// 创建 video 元素
				const videoElement: any = document.createElement('video');
				videoElement.srcObject = stream;
				videoElement.autoplay = true;
				videoElement.playsInline = true;
				videoElement.style.cssText = `
					width: 100%;
					height: 100%;
					object-fit: cover;
				`;

				// 创建 canvas（先不设置尺寸，等视频就绪后再设置）
				const canvas = document.createElement('canvas');
				const context = canvas.getContext('2d');

				// 创建全屏摄像头预览界面
				const cameraModal = document.createElement('div');
				cameraModal.id = 'camera-modal';
				cameraModal.style.cssText = `
					position: fixed;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					background: #000;
					z-index: 9999;
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
				`;

				// 按钮容器
				const buttonContainer = document.createElement('div');
				buttonContainer.style.cssText = `
					position: absolute;
					bottom: 30px;
					width: 100%;
					display: flex;
					justify-content: center;
					gap: 20px;
					padding: 0 20px;
					box-sizing: border-box;
				`;

				// 拍照按钮
				const captureBtn = document.createElement('button');
				captureBtn.textContent = that.translateService.instant('shared_components.common.choose_take_photo_msg') || '拍照';
				captureBtn.style.cssText = `
					padding: 12px 30px;
					background: #007AFF;
					color: white;
					border: none;
					border-radius: 8px;
					font-size: 16px;
					cursor: pointer;
					flex: 1;
					max-width: 150px;
				`;

				// 取消按钮
				const cancelBtn = document.createElement('button');
				cancelBtn.textContent = that.translateService.instant('common.cancel') || '取消';
				cancelBtn.style.cssText = `
					padding: 12px 30px;
					background: #666;
					color: white;
					border: none;
					border-radius: 8px;
					font-size: 16px;
					cursor: pointer;
					flex: 1;
					max-width: 150px;
				`;

				// 关键优化1：等待视频元数据加载完成，获取真实分辨率
				videoElement.addEventListener('loadedmetadata', () => {
					// 视频实际分辨率
					const videoWidth = videoElement.videoWidth;
					const videoHeight = videoElement.videoHeight;
					
					// console.log('摄像头实际分辨率:', videoWidth, 'x', videoHeight);
					
					// 设置 canvas 为视频的实际分辨率
					canvas.width = videoWidth * 4 || 1080;
					canvas.height = videoHeight * 4 || 1920;
					
					// 可选：如果你想限制最大尺寸（比如不让照片太大），可以这样处理
					// const MAX_WIDTH = 1920;
					// const MAX_HEIGHT = 1080;
					// if (videoWidth > MAX_WIDTH || videoHeight > MAX_HEIGHT) {
					//     const ratio = Math.min(MAX_WIDTH / videoWidth, MAX_HEIGHT / videoHeight);
					//     canvas.width = Math.floor(videoWidth * ratio);
					//     canvas.height = Math.floor(videoHeight * ratio);
					// } else {
					//     canvas.width = videoWidth;
					//     canvas.height = videoHeight;
					// }
					
					console.log('canvas最终尺寸:', canvas.width, 'x', canvas.height);
				});

				// 拍照事件
				captureBtn.onclick = () => {
					// 关键优化2：拍照时再次确认视频尺寸（确保万无一失）
					const videoWidth = videoElement.videoWidth;
					const videoHeight = videoElement.videoHeight;
					
					// 如果 canvas 尺寸和视频尺寸不一致，重新设置
					// if (canvas.width !== videoWidth || canvas.height !== videoHeight) {
					// 	canvas.width = videoWidth;
					// 	canvas.height = videoHeight;
					// 	console.log('拍照时重新设置canvas尺寸:', videoWidth, 'x', videoHeight);
					// }
					canvas.width = videoWidth * 4 || 1080;
					canvas.height = videoHeight * 4 || 1920;

					// 绘制当前视频帧
					context.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
					
					// 转换为高质量 JPEG（质量参数可调整 0.8-1.0）
					canvas.toBlob(async (blob) => {
						that.zone.run(() => {
							that.loading = true;
						});
						
						const formData = new FormData();
						formData.append('file', blob, 'camera_' + Date.now() + '.jpg');
						
						// 停止摄像头
						stream.getTracks().forEach(track => track.stop());
						document.body.removeChild(cameraModal);
						// 上传文件
						that.dataService.uploadFile(formData).subscribe(res => {
							if (!res.DATA) {
								that.zone.run(() => {
									that.loading = false;
								});
								that.appService.toastTip(res.MSG, false);
							} else {
								const data = res.DATA;
								that.downloadSingleFile(data.id).then(resOut => {
									that.zone.run(() => {
										let fieldIds = '';
										that.files.forEach((element, index) => {
											if (index !== that.files.length - 1) {
												fieldIds += element.id + ',';
											} else {
												fieldIds += element.id;
											}
										});
										that.fileObjListChange.emit(fieldIds);
										that.loading = false;
									});
								});
							}
						}, (err) => {
							that.zone.run(() => {
								that.loading = false;
							});
							that.appService.toastTip('shared_components.common.get_data_failed', true);
						});
					}, 'image/jpeg', 1); // 提高质量
				};
				// 取消事件
				cancelBtn.onclick = () => {
					stream.getTracks().forEach(track => track.stop());
					document.body.removeChild(cameraModal);
				};
				buttonContainer.appendChild(captureBtn);
				buttonContainer.appendChild(cancelBtn);
				cameraModal.appendChild(videoElement);
				cameraModal.appendChild(buttonContainer);
				document.body.appendChild(cameraModal);
			})
			.catch((err) => {
				console.error('摄像头访问失败:', err);
				let errorMsg = 'shared_components.select_picture_new.camera_access_denied';
				if (err.name === 'NotFoundError') {
					errorMsg = 'shared_components.select_picture_new.camera_not_found';
				}
				that.appService.toastTip(errorMsg, true);
			});
	}

	private chooseImageWeComCameraOnly() {
		const that = this;
		try {
			that.loading = true;
			wx.ready(function () {
				wx.chooseImage({
					count: 1,
					sizeType: ['compressed'],
					sourceType: ['camera'],
					success: function (res) {
						const localIds = res.localIds || [];
						if (!localIds.length) {
							that.zone.run(() => { that.loading = false; });
							return;
						}
						// const formData = new FormData();
						// alert(localIds);
						wx.getLocalImgData({
							localId: localIds[0],
							success: (result) => {
								var localData = result.localData; // localData是图片的base64数据，可以用img标签显示
								const blob = that.base64ToBlob(localData, 'image/jpeg');
								// 现在可以用于 FormData 上传
								const formData = new FormData();
								formData.append('file', blob, 'photo.jpg');
								that.previewImgs = [localData, ...that.previewImgs]
								that.dataService.uploadFile(formData).subscribe(member => {
									if (!member.DATA) {
										that.zone.run(() => { that.loading = false; });
										that.appService.toastTip(member.MSG, false);
									} else {
										const data = member.DATA;
										that.downloadSingleFile(data.id).then(() => {
											that.zone.run(() => {
												let fieldIds = '';
												that.files.forEach((element, index) => {
													if (index !== that.files.length - 1) {
														fieldIds += element.id + ',';
													} else {
														fieldIds += element.id;
													}
												});
												that.fileObjListChange.emit(fieldIds);
												that.changeDetectorRef.detectChanges();
												that.loading = false;
											});
										});
									}
								}, () => {
									that.zone.run(() => { that.loading = false; });
									that.appService.toastTip('shared_components.common.get_data_failed', true);
								});
							},
							fail: function () {
								that.zone.run(() => { that.loading = false; });
								that.appService.toastTip('shared_components.select_picture_new.camera_access_denied', true);
							}
						});
					},
					fail: function (res) {
						that.zone.run(() => { that.loading = false; });
						const msg = res && res.errMsg ? String(res.errMsg) : '';
						if (msg.indexOf('cancel') === -1) {
							that.appService.toastTip('shared_components.select_picture_new.camera_access_denied', true);
						}
					},
					complete: function (res) {
						const msg = res && res.errMsg ? String(res.errMsg) : '';
						if (msg.indexOf('cancel') !== -1) {
							that.zone.run(() => { that.loading = false; });
						}
					}
				});
			});
		} catch (e) {
			that.zone.run(() => { that.loading = false; });
			that.appService.toastTip('shared_components.select_picture_new.camera_access_denied', true);
		}
	}

    blobToPureBase64(blob) {
		return new Promise((resolve, reject) => {
			const reader: any = new FileReader();
			reader.onloadend = () => {
				// 去掉 "data:image/jpeg;base64," 前缀，只保留纯 base64 字符串
				const base64 = reader.result.split(',')[1];
				resolve(base64);
			};
			reader.onerror = reject;
			reader.readAsDataURL(blob);
		});
	}

	base64ToBlob(base64Data, contentType = 'image/jpeg') {
		// 去掉 Base64 头部（如果有）
		const base64 = base64Data.split(',')[1] || base64Data;
		const byteCharacters = atob(base64);
		const byteArrays = [];

		for (let offset = 0; offset < byteCharacters.length; offset += 512) {
			const slice = byteCharacters.slice(offset, offset + 512);
			const byteNumbers = new Array(slice.length);
			for (let i = 0; i < slice.length; i++) {
				byteNumbers[i] = slice.charCodeAt(i);
			}
			const byteArray = new Uint8Array(byteNumbers);
			byteArrays.push(byteArray);
		}

		return new Blob(byteArrays, { type: contentType });
	}

	// 打开图片标注编辑器
	async openAnnotator(event: Event, index: number) {
		event.stopPropagation();
		const file = this.files[index];
		if (!this.isPicSuffix(file)) return;

		// 优先使用已缓存的 blob URL（无跨域问题），否则临时获取
		let imageUrl = this.fileBlobUrls[index];
		if (!imageUrl && file.path) {
			try {
				const blob = await this.fileService.getFileBlob(file.path);
				imageUrl = URL.createObjectURL(blob);
				this.fileBlobUrls[index] = imageUrl;
			} catch {
				imageUrl = file.path;
			}
		}

		const modal = await this.modalController.create({
			component: ImageAnnotatorModalComponent,
			componentProps: { imageUrl },
			cssClass: 'annotator-modal'
		});
		await modal.present();

		const { data } = await modal.onWillDismiss();
		if (!data || !data.blob) return;

		this.loading = true;
		const formData = new FormData();
		formData.append('file', data.blob, `annotated_${Date.now()}.jpg`);

		this.dataService.uploadFile(formData).subscribe(
			(res) => {
				if (!res.DATA) {
					this.zone.run(() => { this.loading = false; });
					this.appService.toastTip(res.MSG, false);
					return;
				}
				this.dataService.getFile(res.DATA.id).subscribe(
					(fileRes) => {
						if (fileRes.DATA) {
							const newFile = {
								id: fileRes.DATA.id,
								download: fileRes.DATA.path,
								path: fileRes.DATA.path,
								originalName: fileRes.DATA.originalName,
								type: fileRes.DATA.type,
								size: fileRes.DATA.size
							};
							const newBlobUrl = URL.createObjectURL(data.blob);
							this.zone.run(() => {
								this.files[index] = newFile;
								this.fileBlobUrls[index] = newBlobUrl;
								const fieldIds = this.files.map(f => f.id).join(',');
								this.fileObjListChange.emit(fieldIds);
								this.loading = false;
							});
						} else {
							this.zone.run(() => { this.loading = false; });
							this.appService.toastTip('shared_components.common.get_data_failed', true);
						}
					},
					() => {
						this.zone.run(() => { this.loading = false; });
						this.appService.toastTip('shared_components.common.get_data_failed', true);
					}
				);
			},
			() => {
				this.zone.run(() => { this.loading = false; });
				this.appService.toastTip('shared_components.common.get_data_failed', true);
			}
		);
	}

}
